// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Yt5m","large":"styles_large__3HUg_","xlarge":"styles_xlarge__1dVRr"};